<template>
  <div class="education-form">
    <div class="question-container"
      :class="$vuetify.breakpoint.smAndDown ? 'rounded-0 ' : (currentStep != 1 ? 'pb-0' : $vuetify.breakpoint.smAndUp ? 'pt-3' : 'pt-0 px-2')">

      <!-- STEPPER -->
      <v-stepper v-model="currentStep" color="transparent" class="education-stepper rounded-0">
        <v-stepper-header v-show="false">
          <v-stepper-step :complete="currentStep > 1" step="1">Tipo de estudio</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="currentStep > 2" step="2">Centro educativo</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="currentStep > 3" step="3">Curso</v-stepper-step>
          <v-divider v-if="isUniversity"></v-divider>
          <v-stepper-step v-if="isUniversity" :complete="currentStep > 4" step="4">Centro universitario</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="currentStep > 5" step="5">Asignaturas</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="6">Resumen</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items class="stepper-items-container">
          <!-- PASO 1: TIPO DE ESTUDIO -->
          <v-stepper-content step="1">

            <p class="mb-4">¿Qué estudios estás cursando?</p>
            <div v-if="loadingStudyTypes" class="text-center py-4 d-flex flex-column justify-center align-center">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
              <p class="mt-2">Cargando tipos de estudio...</p>
            </div>
            <div v-else>
              <v-card v-for="(studyType, i) in studyTypes" :key="i"
                :class="{ 'selected-option': selectedStudyType && selectedStudyType.id === studyType.id }"
                class="option-card mb-3" @click="selectStudyType(studyType)" :ripple="false" flat>
                <v-card-text class="py-1">
                  <div class="d-flex align-center">
                    <div class="pa-2 mr-3" style="background-color: #F7F8F9; border-radius: 10px;">
                      <v-img v-if="studyType.icon_url" :src="url + studyType.icon_url" height="32" width="32" contain
                        style="max-width: 28px; max-height: 28px;" class="pa-2"></v-img>
                    </div>
                    <div>
                      <span class="font-weight-medium mb-0">{{ studyType.name }}</span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </div>

            <div v-if="false && selectedStudyType" class="d-flex justify-end my-6">
              <v-btn class="primary-btn" :disabled="!selectedStudyType" @click="nextStep" :loading="loadingCenters">
                Continuar
              </v-btn>
            </div>
          </v-stepper-content>

          <!-- PASO 2: CENTRO EDUCATIVO -->
          <v-stepper-content step="2" style="position: relative;">
            <div class="breadcrumb-container mb-4">
              <div class="breadcrumb-path">
                <span v-if="studyTypes.length > 1" class="breadcrumb-item clickable" @click="goToStep(1)">{{
                  selectedStudyType ? selectedStudyType.name : 'Tipo de estudio' }}</span>
                <lucide-chevron-right v-if="studyTypes.length > 1" :size="18" class="mx-1" />
                <span class="current-step">Centro educativo</span>
              </div>
            </div>

            <div class="search-container mb-3">
              <v-text-field v-model="searchCenter"
              :style="isLoadingFromUrl ? 'opacity: 0;' : ''"
              placeholder="Buscar centro educativo..."
                prepend-inner-icon="$mdi-magnify" solo dense hide-details clearable ref="centerSearchInput"
                @input="filterCenters" class="search-input"></v-text-field>
            </div>
            <div class="options-list-container">
              <div v-if="!loadingCenters" class="options-list" style="height: calc(100vh - 214px) !important;">
                <v-card v-for="(center, i) in filteredCenters" :key="i"
                  :class="{ 'selected-option': selectedCenter && selectedCenter.id === center.id }"
                  class="option-card mb-3" @click="selectCenter(center)" :ripple="false" flat>
                  <v-card-text :class="center.is_university == 0 ? 'py-1' : 'py-1'">
                    <div class="d-flex align-center">
                      <div :class="center.is_university == 0 ? 'pa-2' : 'pa-0'" class=" mr-3"
                        style="background-color: #F7F8F9; border-radius: 10px;"
                        :style="`background-color: ${center.is_university == 0 ? '#F7F8F9' : 'white'}; border: ${center.is_university == 0 ? 'none' : '1px solid rgb(242 242 242)'};`">
                        <v-img v-if="center.icon_url" :src="url + center.icon_url"
                          :height="center.is_university == 0 ? 28 : 36" :width="center.is_university == 0 ? 28 : 36"
                          contain class="pa-2 rounded university-icon"></v-img>
                      </div>
                      <div class="d-flex align-center" style="flex: 1;">
                        <span class="font-weight-medium mb-0" style="flex: 1;">{{ center.name }}</span>
                        <v-chip
                          v-if="center.short_name && center.is_university == 1 && (selectedStudyType.id == 5 || selectedStudyType.id == 6)"
                          class="ml-2 caption grey--text">{{
                            center.short_name }}</v-chip>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </div>

            <div class="d-flex justify-space-between pt-3">
              <v-btn text @click="prevStepSmooth">
                <lucide-arrow-left :size="20" class="mx-1" />
                Atrás
              </v-btn>
              <!-- <v-btn v-if="selectedCenter" class="primary-btn" :disabled="!selectedCenter" @click="nextStep" :loading="loadingCourses">
                Continuar
              </v-btn> -->
            </div>
          </v-stepper-content>

          <!-- PASO 3: CURSO -->
          <v-stepper-content step="3">
            <div class="breadcrumb-container mb-4">
              <div class="breadcrumb-path">
                <span v-if="studyTypes.length > 1" class="breadcrumb-item clickable" @click="goToStep(1)">{{
                  selectedStudyType ? selectedStudyType.name : 'Tipo de estudio' }}</span>
                <lucide-chevron-right v-if="studyTypes.length > 1" :size="18" class="mx-1" />
                <span v-if="educationCenters.length > 1" class="breadcrumb-item clickable" @click="goToStep(2)">{{
                  selectedCenter ? selectedCenter.name : 'Centro educativo' }}</span>
                <lucide-chevron-right v-if="educationCenters.length > 1" :size="18" class="mx-1" />
                <span class="current-step">Curso</span>
              </div>
            </div>

            <p class="mb-4">¿Qué curso estás estudiando?
              <!-- en {{ selectedCenter ? selectedCenter.name : '' }}? -->
            </p>
            <div class="search-container mb-3">
              <v-text-field v-model="searchCourse" 
              :style="isLoadingFromUrl ? 'opacity: 0;' : ''"
              placeholder="Buscar curso..." prepend-inner-icon="$mdi-magnify" solo
                dense hide-details clearable ref="courseSearchInput" @input="filterCourses"
                class="search-input"></v-text-field>
            </div>
            <div v-if="loadingCourses" class="text-center py-4 d-flex flex-column justify-center align-center">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
              <p class="mt-2">Cargando cursos...</p>
            </div>
            <div v-else class="options-list" style="height: calc(100vh - 269px) !important;">
              <v-card v-for="(course, i) in filteredCourses" :key="i"
                :class="{ 'selected-option': selectedCourse && selectedCourse.id === course.id }"
                class="option-card mb-3" @click="selectCourse(course)" :ripple="false" flat>
                <v-card-text class="py-1">
                  <div class="d-flex align-center">
                    <div class="pa-2 mr-3" style="background-color: #F7F8F9; border-radius: 10px;">
                      <v-img v-if="course.icon_url" :src="url + course.icon_url" height="32" width="32" contain
                        style="max-width: 28px; max-height: 28px;" class="pa-2"></v-img>
                    </div>
                    <div class="d-flex align-center" style="flex: 1;">
                      <span class="font-weight-medium mb-0" style="flex: 1;">{{ course.name }}</span>
                      <!-- <v-chip v-if="course.short_name && (selectedStudyType.id == 5 || selectedStudyType.id == 6)" class="caption grey--text ml-2">{{ course.short_name }}</v-chip> -->
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </div>

            <div class="d-flex justify-space-between mt-6">
              <v-btn text @click="prevStepSmooth">
                <lucide-arrow-left :size="20" class="mx-1" />
                Atrás
              </v-btn>
              <!-- <v-btn v-if="selectedCourse" class="primary-btn" :disabled="!selectedCourse" @click="nextStep" :loading="isUniversity ? loadingUniversityCenters : loadingSubjects">
                Continuar
              </v-btn> -->
            </div>
          </v-stepper-content>

          <!-- PASO 4: CENTRO UNIVERSITARIO (solo para universidades) -->
          <v-stepper-content step="4" v-if="isUniversity">
            <div class="breadcrumb-container mb-4">
              <div class="breadcrumb-path">
                <span v-if="studyTypes.length > 1" class="breadcrumb-item clickable" @click="goToStep(1)">{{
                  selectedStudyType ? selectedStudyType.name : 'Tipo de estudio' }}</span>
                <lucide-chevron-right v-if="studyTypes.length > 1" :size="18" class="mx-1" />
                <span v-if="educationCenters.length > 1" class="breadcrumb-item clickable" @click="goToStep(2)">{{
                  selectedCenter ? selectedCenter.name : 'Centro educativo' }}</span>
                <lucide-chevron-right v-if="educationCenters.length > 1" :size="18" class="mx-1" />
                <span v-if="courses.length > 1" class="breadcrumb-item clickable" @click="goToStep(3)">{{ selectedCourse
                  ? selectedCourse.name : 'Curso' }}</span>
                <lucide-chevron-right v-if="courses.length > 1" :size="18" class="mx-1" />
                <span v-if="isUniversity && universityCenters.length > 1" class="breadcrumb-item clickable"
                  @click="goToStep(4)">{{ selectedUniversityCenter ? selectedUniversityCenter.name : 'Centro universitario' }}</span>
                <lucide-chevron-right v-if="isUniversity && universityCenters.length > 1" :size="18" class="mx-1" />
                <span class="current-step">Centro universitario</span>
              </div>
            </div>

            <p class="mb-4">¿En qué facultad o centro universitario estudias?</p>
            <div class="search-container mb-3">
              <v-text-field v-model="searchUniversityCenter" placeholder="Buscar facultad o centro universitario..."
                prepend-inner-icon="$mdi-magnify" solo dense hide-details clearable ref="universityCenterSearchInput"
                :style="isLoadingFromUrl ? 'opacity: 0;' : ''"
                @input="filterUniversityCenters" class="search-input"></v-text-field>
            </div>
            <div v-if="loadingUniversityCenters" class="text-center py-4 d-flex flex-column justify-center align-center">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
              <p class="mt-2">Cargando centros universitarios...</p>
            </div>
            <div v-else class="options-list" style="height: calc(100vh - 268px) !important;">
              <v-card v-for="(univCenter, i) in filteredUniversityCenters" :key="i"
                :class="{ 'selected-option': selectedUniversityCenter && selectedUniversityCenter.id === univCenter.id }"
                class="option-card mb-3" @click="selectUniversityCenter(univCenter)" :ripple="false" flat>
                <v-card-text class="py-3">
                  <div class="d-flex align-center">
                    <div class="pa-2 mr-3" style="background-color: #F7F8F9; border-radius: 10px;">
                      <v-img v-if="univCenter.icon_url" :src="url + univCenter.icon_url" height="32" width="32" contain
                        style="max-width: 28px; max-height: 28px;" class="pa-2"></v-img>
                    </div>
                    <div>
                      <span class="font-weight-medium mb-0">{{ univCenter.name }}</span>
                      <p v-if="univCenter.short_name" class="caption grey--text">{{ univCenter.short_name }}</p>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </div>

            <div class="d-flex justify-space-between mt-6">
              <v-btn text @click="prevStepSmooth">
                <lucide-arrow-left :size="20" class="mx-1" />
                Atrás
              </v-btn>
              <!-- <v-btn v-if="selectedUniversityCenter" class="primary-btn" :disabled="!selectedUniversityCenter" @click="nextStep" :loading="loadingSubjects">
                Continuar
              </v-btn> -->
            </div>
          </v-stepper-content>

          <!-- PASO 5: ASIGNATURAS -->
          <v-stepper-content step="5">

            <lucide-x 
            v-if="$route.query.from === 'app'"
            class="close-btn" 
            style="position: absolute; top: 20px; right: 20px; cursor: pointer;"
            @click="$router.push('/app')"></lucide-x>


            <div class="breadcrumb-container" :class="$vuetify.breakpoint.xs ? 'mb-0' : 'mb-4'">
              <div class="breadcrumb-path">
                <span v-if="studyTypes.length > 1" class="breadcrumb-item clickable" @click="goToStep(1)">{{
                  selectedStudyType ? selectedStudyType.name : 'Tipo de estudio' }}</span>
                <lucide-chevron-right v-if="studyTypes.length > 1" :size="18" class="mx-1" />
                <span v-if="educationCenters.length > 1" class="breadcrumb-item clickable" @click="goToStep(2)">{{
                  selectedCenter ? selectedCenter.name : 'Centro educativo' }}</span>
                <lucide-chevron-right v-if="educationCenters.length > 1" :size="18" class="mx-1" />
                <span v-if="courses.length > 1" class="breadcrumb-item clickable" @click="goToStep(3)">{{ selectedCourse
                  ? selectedCourse.name : 'Curso' }}</span>
                <lucide-chevron-right v-if="courses.length > 1" :size="18" class="mx-1" />
                <span v-if="isUniversity && universityCenters.length > 1" class="breadcrumb-item clickable"
                  @click="goToStep(4)">{{ selectedUniversityCenter ? selectedUniversityCenter.name : 'Centro universitario' }}</span>
                <lucide-chevron-right v-if="isUniversity && universityCenters.length > 1" :size="18" class="mx-1" />
                <span class="current-step">Asignaturas</span>
              </div>
            </div>

            <div class="d-flex justify-space-between align-center mb-4">
              <p class="mb-0">¿Qué asignaturas estás cursando?</p>
              <v-btn v-if="!loadingSubjects && subjects.length > 0" small outlined color="#42b848"
                class="select-all-btn" @click="selectAllSubjects">
                {{ selectedSubjects.length === subjects.length ? "Deseleccionar todas" : "Seleccionar todas" }}
              </v-btn>
            </div>
            <div class="search-container mb-3">
              <v-text-field v-model="searchSubject" placeholder="Buscar asignaturas..."
                prepend-inner-icon="$mdi-magnify" solo dense hide-details clearable ref="subjectSearchInput"
                :style="isLoadingFromUrl ? 'opacity: 0;' : ''"
                @input="filterSubjects" class="search-input"></v-text-field>
            </div>
            <div v-if="loadingSubjects" class="text-center py-4 d-flex flex-column justify-center align-center">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
              <p class="mt-2">Cargando asignaturas...</p>
            </div>
            <div v-else>
              <!-- Mensaje cuando no hay asignaturas -->
              <div v-if="subjects.length === 0 && !loadingSubjects" class="no-subjects-message">
                <v-alert type="info" text color="#42b848" class="mb-4">
                  No encontramos asignaturas para este curso. Puedes añadir tus propias asignaturas.
                </v-alert>

                <v-form ref="customSubjectForm" v-model="customSubjectFormValid" @submit.prevent="addCustomSubject">
                  <p class="mb-3">Añade una asignatura personalizada:</p>
                  <div class="custom-subject-form mb-3">
                    <v-text-field v-model="newSubjectName" label="Nombre de la asignatura"
                      placeholder="Ej: Matemáticas, Física, Historia..." outlined dense hide-details="auto"
                      :style="isLoadingFromUrl ? 'opacity: 0;' : ''"
                      :rules="[v => !!v || 'El nombre es obligatorio']" class="mb-2"></v-text-field>

                    <div class="d-flex justify-space-between mt-3">
                      <div></div>
                      <v-btn color="#42b848" class="white--text ml-2"
                        :disabled="!newSubjectName || newSubjectName.trim() === ''" @click="addCustomSubject"
                        :loading="addingCustomSubject">
                        Añadir asignatura
                      </v-btn>
                    </div>
                  </div>
                </v-form>
              </div>

              <div v-if="subjects.length > 0" class="options-list"
                 :style="$vuetify.breakpoint.smAndUp ? 'height: calc(100vh - 314px) !important;' : 'height: calc(100vh - 324px) !important;'">

                <div v-if="showAddMoreSubjectsForm">
                  <v-form ref="moreCustomSubjectForm" v-model="customSubjectFormValid"
                    @submit.prevent="addCustomSubject">
                    <div class="custom-subject-form mb-3">
                      <v-text-field v-model="newSubjectName" label="Nombre de la asignatura"
                        placeholder="Ej: Matemáticas, Física, Historia..." outlined dense hide-details="auto"
                        :autofocus="!isLoadingFromUrl" :rules="[v => !!v || 'El nombre es obligatorio']"
                        :style="isLoadingFromUrl ? 'opacity: 0;' : ''"
                        class="mb-2 white"></v-text-field>

                      <div class="d-flex justify-end mt-3">
                        <v-btn color="#42b848" class="white--text primary-btn"
                          :disabled="!newSubjectName || newSubjectName.trim() === ''" @click="addCustomSubject"
                          :loading="addingCustomSubject">
                          Añadir asignatura
                        </v-btn>
                      </div>
                    </div>
                  </v-form>
                </div>

                <div v-else>
                  <!-- Lista de asignaturas -->
                  <v-card v-for="(subject, i) in filteredSubjects" :key="i"
                    :class="{ 'selected-option': isSubjectSelected(subject), 'custom-subject': !subject.is_verified }"
                    class="option-card mb-3" @click="toggleSubject(subject)" :ripple="false" flat
                    >
                    <v-card-text class="py-3">
                      <div class="d-flex align-center">

                        <svg v-if="isSubjectSelected(subject)" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                          viewBox="0 0 24 24" fill="none" stroke="#42b848" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round" class="mr-3 lucide lucide-square-check-icon lucide-square-check">
                          <rect width="18" height="18" x="3" y="3" rx="2" />
                          <path d="m9 12 2 2 4-4" />
                        </svg>

                        <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                          fill="none" stroke="#e0e0e0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="mr-3 lucide lucide-square-icon lucide-square">
                          <rect width="18" height="18" x="3" y="3" rx="2" />
                        </svg>

                        <div class="d-flex align-center" style="flex: 1;">
                          <span class="font-weight-medium mb-0" style="flex: 1;">{{ subject.name }}</span>
                          <v-chip v-if="!subject.is_verified" x-small class="ml-2 px-1" color="#FFF3E0"
                            text-color="#FF9800">Pendiente</v-chip>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>


              </div>

              <!-- Formulario para añadir más asignaturas cuando ya hay algunas -->
              <div v-if="subjects.length > 0" class="mt-4">
                <div class="d-flex justify-center">
                  <v-btn small outlined color="#42b848" class="mb-3"
                    @click="showAddMoreSubjectsForm = !showAddMoreSubjectsForm">
                    <lucide-plus v-if="!showAddMoreSubjectsForm" :size="18" class="mx-1" />
                    {{ showAddMoreSubjectsForm ? 'Cancelar' : 'Añadir otra asignatura' }}
                  </v-btn>
                </div>

              </div>
            </div>

            <div class="d-flex justify-space-between align-center">
              <v-btn text @click="prevStepSmooth" class="mt-3">
                <lucide-arrow-left :size="20" class="mx-1" />
                {{$route.query.from === 'app' ? 'Escoger otro curso' : 'Atrás'}}
              </v-btn>
              <v-btn class="primary-btn" :disabled="!hasSelectedSubjects" @click="goToSummary">
                Continuar
              </v-btn>
            </div>
          </v-stepper-content>

          <!-- PASO 6: RESUMEN -->
          <v-stepper-content step="6">
            <div class="breadcrumb-container mb-4">
              <div class="breadcrumb-path">
                <span v-if="studyTypes.length > 1" class="breadcrumb-item clickable" @click="goToStep(1)">{{
                  selectedStudyType ? selectedStudyType.name : 'Tipo de estudio' }}</span>
                <lucide-chevron-right v-if="studyTypes.length > 1" :size="18" class="mx-1" />
                <span v-if="educationCenters.length > 1" class="breadcrumb-item clickable" @click="goToStep(2)">{{
                  selectedCenter ? selectedCenter.name : 'Centro educativo' }}</span>
                <lucide-chevron-right v-if="educationCenters.length > 1" :size="18" class="mx-1" />
                <span v-if="courses.length > 1" class="breadcrumb-item clickable" @click="goToStep(3)">{{ selectedCourse
                  ? selectedCourse.name : 'Curso' }}</span>
                <lucide-chevron-right v-if="courses.length > 1" :size="18" class="mx-1" />
                <span v-if="isUniversity && universityCenters.length > 1" class="breadcrumb-item clickable"
                  @click="goToStep(4)">{{ selectedUniversityCenter ? selectedUniversityCenter.name : 'Centro universitario' }}</span>
                <lucide-chevron-right v-if="isUniversity && universityCenters.length > 1" :size="18" class="mx-1" />
                <span class="breadcrumb-item clickable" @click="goToStep(5)">Asignaturas ({{ selectedSubjects.length
                  }})</span>
                <lucide-chevron-right v-if="courses.length > 1" :size="18" class="mx-1" />
                <span class="current-step">Resumen</span>
              </div>
            </div>

            <span class="mb-4">Resumen de tu información académica</span>

            <v-card class="summary-card my-4" outlined style="height: calc(100vh - 214px) !important;">
              <v-card-text style="height: calc(100vh - 214px) !important; overflow-y: auto;">
                <p class="font-weight-bold mb-1">Tipo de estudio:</p>
                <p class="mb-3">{{ selectedStudyType ? selectedStudyType.name : '-' }}</p>

                <p class="font-weight-bold mb-1">Centro educativo:</p>
                <p class="mb-3">{{ selectedCenter ? selectedCenter.name : '-' }}</p>

                <p class="font-weight-bold mb-1">Curso:</p>
                <p class="mb-3">{{ selectedCourse ? selectedCourse.name : '-' }}</p>

                <template v-if="isUniversity && selectedUniversityCenter">
                  <p class="font-weight-bold mb-1">Centro universitario:</p>
                  <p class="mb-3">{{ selectedUniversityCenter.name }}</p>
                </template>

                <p class="font-weight-bold mb-1">Asignaturas seleccionadas:</p>
                <v-chip-group column>
                  <v-chip v-for="subject in selectedSubjects" :key="subject.id" class="subject-chip" small>
                    {{ subject.name }}
                    <svg v-if="!subject.is_verified" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                      viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" class="lucide lucide-badge-check-icon  mx-1 lucide-badge-check">
                      <path
                        d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" />
                      <path d="m9 12 2 2 4-4" />
                    </svg>
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>

            <div class="d-flex justify-space-between align-center">
              <v-btn text @click="prevStepSmooth">
                <lucide-arrow-left :size="20" class="mx-1" />
                Atrás
              </v-btn>
              <v-btn class="primary-btn mb-1" @click="saveEducationInfo" :loading="isSaving">
                Confirmar y guardar
              </v-btn>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>

      <!-- Indicador de carga mientras se guardan los datos -->
      <v-overlay :value="isSaving" opacity="0.8">
        <div class="d-flex justify-center align-center flex-column">
          <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
          <p class="mt-4 white--text">Guardando tu información académica...</p>
        </div>
      </v-overlay>

      <!-- Indicador de carga mientras se carga desde la URL -->
      <v-overlay :value="isLoadingFromUrl" opacity="1" color="white">
        <div class="d-flex justify-center align-center flex-column" style="z-index: 1000; background-color: white;">
          <v-progress-circular indeterminate size="64" color="primary" style="z-index: 1000;"></v-progress-circular>
          <span class="mt-4" style="z-index: 1000;">Cargando información académica...</span>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import ArrowLeft from "/node_modules/lucide-vue/dist/esm/icons/arrow-left.js"
import ChevronRight from "/node_modules/lucide-vue/dist/esm/icons/chevron-right.js"
import Plus from "/node_modules/lucide-vue/dist/esm/icons/plus.js"
import Minus from "/node_modules/lucide-vue/dist/esm/icons/minus.js"
import X from "/node_modules/lucide-vue/dist/esm/icons/x.js"

export default {
  name: 'EducationForm',
  props: {
    userId: {
      type: Number,
      required: true
    }
  },  
  components: {
    LucideArrowLeft: ArrowLeft,
    LucideChevronRight: ChevronRight,
    LucidePlus: Plus,
    LucideMinus: Minus,
    LucideX: X,
  },
  data() {
    return {
      currentStep: 1,
      isSaving: false,
      isLoadingFromUrl: false, // Estado para controlar si estamos cargando desde la URL

      // Paso 1: Tipo de estudio
      selectedStudyType: null,
      studyTypes: [],
      loadingStudyTypes: false,

      // Paso 2: Centro educativo
      selectedCenter: null,
      educationCenters: [],
      filteredCenters: [],
      searchCenter: '',
      loadingCenters: false,

      // Paso 3: Curso
      selectedCourse: null,
      courses: [],
      filteredCourses: [],
      searchCourse: '',
      loadingCourses: false,

      // Paso 4: Centro universitario (solo para universidades)
      selectedUniversityCenter: null,
      universityCenters: [],
      filteredUniversityCenters: [],
      searchUniversityCenter: '',
      loadingUniversityCenters: false,

      // Paso 5: Comunidad (se selecciona automáticamente)
      selectedCommunity: null,

      // Paso 6: Asignaturas
      selectedSubjects: [],
      subjects: [],
      filteredSubjects: [],
      searchSubject: '',
      loadingSubjects: false,
      userSubjects: [], // Asignaturas del usuario para la selección automática

      url: process.env.VUE_APP_AXIOS_URI,

      customSubjectFormValid: true,
      newSubjectName: '',
      showAddMoreSubjectsForm: false,
      addingCustomSubject: false,
    }
  },
  computed: {
    isUniversity() {
      return this.selectedCenter && this.selectedCenter.is_university === 1;
    },
    destinationStep() {
      // Si es universidad, el paso después del curso es el centro universitario
      if (this.isUniversity && this.currentStep === 3) {
        return 4;
      }

      // Si no es universidad, o si estamos en otro paso, avanzamos normalmente
      if (this.currentStep === 3 && !this.isUniversity) {
        return 5; // Saltamos el paso 4 (centro universitario)
      }

      return this.currentStep + 1;
    },
    currentStepName() {
      const stepNames = {
        1: 'Tipo de estudio',
        2: 'Centro educativo',
        3: 'Curso',
        4: 'Centro universitario',
        5: 'Asignaturas',
        6: 'Resumen'
      };
      return stepNames[this.currentStep] || '';
    },
    canSearchSubjects() {
      return this.selectedCourse &&
        (!this.isUniversity || (this.isUniversity && this.selectedUniversityCenter));
    },
    hasSelectedSubjects() {
      return this.selectedSubjects.length > 0;
    }
  },
  methods: {
    nextStep() {
      // Marcar como loading según el paso actual
      if (this.currentStep === 1 && this.selectedStudyType) {
        this.loadEducationCentersWithoutNavigation();
      } else if (this.currentStep === 2 && this.selectedCenter) {
        this.loadCoursesWithoutNavigation();
      } else if (this.currentStep === 3 && this.selectedCourse) {
        if (this.isUniversity) {
          this.loadUniversityCentersWithoutNavigation();
        } else {
          this.searchCommunityWithoutNavigation();
        }
      } else if (this.currentStep === 4 && this.isUniversity && this.selectedUniversityCenter) {
        this.searchCommunityWithoutNavigation();
      } else {
        // Si no hay ninguna carga que hacer, simplemente avanzar al siguiente paso
        this.currentStep = this.destinationStep;
        this.resetScroll();
        this.updateUrlParams();
      }
    },
    prevStep() {
      // Guardamos el paso actual antes de cambiarlo
      const currentStepBefore = this.currentStep;

      if (this.currentStep === 5 && !this.isUniversity) {
        // Si estamos en asignaturas y no es universidad, volvemos a curso
        this.currentStep = 3;
      } else if (this.currentStep === 6) {
        // Si estamos en resumen, volvemos a asignaturas
        this.currentStep = 5;
      } else {
        this.currentStep--;
      }

      // Limpiamos variables según el paso del que salimos
      this.clearVariablesFromStep(currentStepBefore);

      this.resetScroll();
      this.updateUrlParams();
    },

    // Método mejorado para navegar hacia atrás evitando animaciones innecesarias
    async prevStepSmooth() {
      // Empezamos con el paso inmediatamente anterior
      let targetStep = this.determineInitialPrevStep();

      // Verificamos si debemos retroceder más (casos donde hay una sola opción)
      while (targetStep > 1 && this.shouldSkipStep(targetStep)) {
        targetStep--;
      }

      // Limpiamos variables según el paso del que salimos
      this.clearVariablesFromStep(this.currentStep);

      // Navegamos al paso objetivo
      this.currentStep = targetStep;
      this.resetScroll();
      this.updateUrlParams();
    },

    // Limpia las variables según el paso que dejamos atrás
    clearVariablesFromStep(step) {
      switch (step) {
        case 2: // Si salimos del paso de centros educativos
          // Solo limpiamos si vamos al paso 1
          if (this.currentStep === 1) {
            this.selectedCenter = null;
            this.filteredCenters = [...this.educationCenters];
            this.searchCenter = '';

            // Limpiamos también los pasos dependientes
            this.selectedCourse = null;
            this.courses = [];
            this.filteredCourses = [];

            this.selectedUniversityCenter = null;
            this.universityCenters = [];
            this.filteredUniversityCenters = [];

            this.selectedCommunity = null;
          }
          break;

        case 3: // Si salimos del paso de cursos
          // Solo limpiamos si vamos al paso 2 o 1
          if (this.currentStep <= 2) {
            this.selectedCourse = null;
            this.filteredCourses = [...this.courses];
            this.searchCourse = '';

            // Limpiamos también los pasos dependientes
            this.selectedUniversityCenter = null;
            this.universityCenters = [];
            this.filteredUniversityCenters = [];

            this.selectedCommunity = null;
          }
          break;

        case 4: // Si salimos del paso de centros universitarios
          // Solo limpiamos si vamos al paso 3 o anterior
          if (this.currentStep <= 3) {
            this.selectedUniversityCenter = null;
            this.filteredUniversityCenters = [...this.universityCenters];
            this.searchUniversityCenter = '';

            this.selectedCommunity = null;
          }
          break;

        case 5: // Si salimos del paso de asignaturas
          // Limpiamos las asignaturas solo si no vamos al paso de resumen
          if (this.currentStep !== 6) {
            this.searchSubject = '';
          }
          break;

        case 6: // Si salimos del paso de resumen
          // No necesitamos limpiar nada aquí
          break;
      }
    },

    // Determina el paso inicial para retroceder
    determineInitialPrevStep() {
      if (this.currentStep === 5 && !this.isUniversity) {
        return 3; // De asignaturas volvemos a curso (si no es universidad)
      } else if (this.currentStep === 6) {
        return 5; // Del resumen volvemos a asignaturas
      } else {
        return this.currentStep - 1; // Retrocedemos un paso normalmente
      }
    },

    // Determina si un paso debe ser saltado (tiene una sola opción)
    shouldSkipStep(step) {
      switch (step) {
        case 1: // Paso 1: Tipo de estudio
          return this.studyTypes.length === 1;

        case 2: // Paso 2: Centro educativo
          return this.educationCenters.length === 1;

        case 3: // Paso 3: Curso
          return this.courses.length === 1;

        case 4: // Paso 4: Centro universitario
          return this.universityCenters.length === 1;

        case 5: // Paso 5: Asignaturas - nunca se salta
          return false;

        default:
          return false;
      }
    },

    goToStep(step) {
      // Guardamos el paso actual antes de cambiarlo
      const currentStepBefore = this.currentStep;

      // Si estamos retrocediendo
      if (step < this.currentStep) {
        // Limpiamos variables según el paso del que salimos
        this.clearVariablesFromStep(currentStepBefore);
      }

      this.currentStep = step;
      this.resetScroll();
      this.updateUrlParams();
    },

    resetScroll() {
      this.$nextTick(() => {
        const optionsLists = this.$el.querySelectorAll('.options-list');
        if (optionsLists && optionsLists.length > 0) {
          optionsLists.forEach(list => {
            if (list) list.scrollTop = 0;
          });
        }

        const questionContainer = this.$el.querySelector('.question-container');
        if (questionContainer) {
          questionContainer.scrollTop = 0;
        }

        if (this.currentStep == 1) {
          window.scrollTo(0, 150);
        }
        else {
          window.scrollTo(0, 0);
        }
      });
    },

    selectStudyType(studyType) {
      if (this.loadingCenters) return; // Prevent action if already loading next step's data
      this.selectedStudyType = studyType;
      this.updateUrlParams();
      this.nextStep();
    },

    selectCenter(center) {
      if (this.loadingCourses) return; // Prevent action if already loading next step's data
      this.selectedCenter = center;
      this.updateUrlParams();
      this.nextStep();
    },

    selectCourse(course) {
      if (this.isUniversity ? this.loadingUniversityCenters : this.loadingSubjects) return;
      this.selectedCourse = course;
      this.updateUrlParams();
      this.nextStep();
    },

    selectUniversityCenter(universityCenter) {
      if (this.loadingSubjects) return; // Prevent action if already loading next step's data
      this.selectedUniversityCenter = universityCenter;
      this.updateUrlParams();
      this.nextStep();
    },

    isSubjectSelected(subject) {
      return this.selectedSubjects.some(s => s.id === subject.id);
    },

    toggleSubject(subject) {
      const index = this.selectedSubjects.findIndex(s => s.id === subject.id);
      if (index === -1) {
        this.selectedSubjects.push(subject);
      } else {
        this.selectedSubjects.splice(index, 1);
      }
      this.updateUrlParams();
    },

    selectAllSubjects() {
      // Si ya están todas seleccionadas, deseleccionamos todas
      if (this.selectedSubjects.length === this.subjects.length) {
        this.selectedSubjects = [];
      } else {
        // Seleccionamos todas las asignaturas
        this.selectedSubjects = [...this.subjects];
      }
      this.updateUrlParams();
    },

    goToSummary() {
      if (this.selectedSubjects.length > 0) {
        this.currentStep = 6;
        this.resetScroll();
        this.updateUrlParams();
      }
    },

    async loadStudyTypes() {
      this.loadingStudyTypes = true;
      try {
        const response = await this.axios.get('/education/study-types');
        this.studyTypes = response.data;
        this.studyTypes = this.studyTypes.filter(studyType => studyType.name !== "Bachillerato");

        if (this.studyTypes.length === 1) {
          this.selectedStudyType = this.studyTypes[0];
          await this.loadEducationCentersWithoutNavigation();
        }
      } catch (error) {
        console.error('Error al cargar tipos de estudio:', error);
        this.studyTypes = [];
      } finally {
        this.loadingStudyTypes = false;
      }
    },

    async loadEducationCentersWithoutNavigation() {
      if (!this.selectedStudyType) return;

      this.loadingCenters = true;
      try {
        const response = await this.axios.get('/education/centers', {
          params: {
            study_type_id: this.selectedStudyType.id
          }
        });
        this.educationCenters = response.data;
        this.filteredCenters = [...this.educationCenters];

        if (this.educationCenters.length === 1) {
          this.selectedCenter = this.educationCenters[0];
          await this.loadCoursesWithoutNavigation();
        } else {
          this.currentStep = this.destinationStep;
          this.resetScroll();
          this.updateUrlParams();
          this.$nextTick(() => {
            if (this.$refs.centerSearchInput && !this.isLoadingFromUrl) {
              this.$refs.centerSearchInput.$el.querySelector('input').focus();
            }
          });
        }
      } catch (error) {
        console.error('Error al cargar centros educativos:', error);
        this.educationCenters = [];
        this.filteredCenters = [];
        this.currentStep = this.destinationStep;
        this.resetScroll();
        this.updateUrlParams();
      } finally {
        this.loadingCenters = false;
      }
    },

    async loadCoursesWithoutNavigation() {
      if (!this.selectedCenter) return;

      this.loadingCourses = true;
      try {
        const response = await this.axios.get('/education/courses', {
          params: {
            center_id: this.selectedCenter.id,
            study_type_id: this.selectedStudyType.id
          }
        });
        this.courses = response.data;
        this.filteredCourses = [...this.courses];

        if (this.courses.length === 1) {
          this.selectedCourse = this.courses[0];

          if (this.isUniversity) {
            await this.loadUniversityCentersWithoutNavigation();
          } else {
            await this.searchCommunityWithoutNavigation();
          }
        } else {
          this.currentStep = this.destinationStep;
          this.resetScroll();
          this.updateUrlParams();
          this.$nextTick(() => {
            if (this.$refs.courseSearchInput && !this.isLoadingFromUrl) {
              this.$refs.courseSearchInput.$el.querySelector('input').focus();
            }
          });
        }
      } catch (error) {
        console.error('Error al cargar cursos:', error);
        this.courses = [];
        this.filteredCourses = [];
        this.currentStep = this.destinationStep;
        this.resetScroll();
        this.updateUrlParams();
      } finally {
        this.loadingCourses = false;
      }
    },

    async loadUniversityCentersWithoutNavigation() {
      if (!this.selectedCourse || !this.isUniversity) return;

      this.loadingUniversityCenters = true;
      try {
        const response = await this.axios.get('/education/university-centers', {
          params: {
            study_id: this.selectedCourse.original_id,
            university_id: this.selectedCenter.original_id
          }
        });
        this.universityCenters = response.data;
        this.filteredUniversityCenters = [...this.universityCenters];

        if (this.universityCenters.length === 1) {
          this.selectedUniversityCenter = this.universityCenters[0];
          await this.searchCommunityWithoutNavigation();
        } else {
          this.currentStep = this.destinationStep;
          this.resetScroll();
          this.updateUrlParams();
          this.$nextTick(() => {
            if (this.$refs.universityCenterSearchInput && !this.isLoadingFromUrl) {
              this.$refs.universityCenterSearchInput.$el.querySelector('input').focus();
            }
          });
        }
      } catch (error) {
        console.error('Error al cargar centros universitarios:', error);
        this.universityCenters = [];
        this.filteredUniversityCenters = [];
        this.currentStep = this.destinationStep;
        this.resetScroll();
        this.updateUrlParams();
      } finally {
        this.loadingUniversityCenters = false;
      }
    },

    async searchCommunityWithoutNavigation() {
      this.loadingSubjects = true;
      try {
        let params = {};

        if (this.isUniversity && this.selectedUniversityCenter) {
          params = {
            study_id: this.selectedCourse.id,
            center_id: this.selectedCenter.id,
            university_center_id: this.selectedUniversityCenter.id
          };
        } else if (!this.isUniversity && this.selectedCourse) {
          params = {
            study_id: this.selectedCourse.id,
            center_id: this.selectedCenter.id
          };
        } else {
          this.loadingSubjects = false;
          return;
        }

        const response = await this.axios.get('/education/community', { params });

        if (response.data && response.data.id) {
          this.selectedCommunity = response.data;
          console.log('Comunidad seleccionada:', this.selectedCommunity);
          await this.loadSubjectsWithoutNavigation();
        } else {
          this.currentStep = this.destinationStep;
          this.resetScroll();
          this.updateUrlParams();
        }
      } catch (error) {
        console.error('Error al buscar comunidad:', error);
        this.selectedCommunity = null;
        this.currentStep = this.destinationStep;
        this.resetScroll();
        this.updateUrlParams();
      }
    },

    async fetchUserSubjects() {
        // First fetch user's current subjects
        try {
          const userSubjectsResponse = await this.axios.get('/education/user-subjects', {
            params: {
              user_id: this.userId
            }
          });
          if (userSubjectsResponse.data && Array.isArray(userSubjectsResponse.data)) {
            this.userSubjects = userSubjectsResponse.data;
            console.log('Asignaturas del usuario cargadas:', this.userSubjects);
          }
        } catch (error) {
          console.error('Error al cargar asignaturas del usuario:', error);
          this.userSubjects = [];
        }
    },

    async loadSubjectsWithoutNavigation() {
      if (!this.selectedCommunity && !this.canSearchSubjects) return;

      this.loadingSubjects = true;
      try {
        // Then fetch available subjects for the course
        let params = {};
        if (this.selectedCommunity) {
          params.community_id = this.selectedCommunity.id;
        } else {
          params.study_id = this.selectedCourse.id;
          params.center_id = this.selectedCenter.id;

          if (this.isUniversity && this.selectedUniversityCenter) {
            params.university_center_id = this.selectedUniversityCenter.id;
          }
        }

        console.log('Solicitando asignaturas con parámetros:', params);
        const response = await this.axios.get('/education/subjects', { params });
        console.log('Asignaturas recibidas:', response.data);
        
        this.subjects = [...response.data]; // Asegúrate de crear un nuevo array
        this.$nextTick(() => {
          this.filteredSubjects = [...this.subjects];
          
          // Clear previous selections
          this.selectedSubjects = [];
          
          // Auto-select subjects that match user's current subjects
          if (this.userSubjects && this.userSubjects.length > 0) {
            const userSubjectIds = this.userSubjects.map(s => s.subject_id);
            console.log('IDs de asignaturas del usuario:', userSubjectIds);
            this.selectedSubjects = this.subjects.filter(subject => 
              userSubjectIds.includes(subject.original_id)
            );
            console.log('Asignaturas seleccionadas automáticamente:', this.selectedSubjects);
          }

          if (this.subjects.length === 1) {
            this.toggleSubject(this.subjects[0]);
            this.goToStep(6);
          } else {
            this.goToStep(5);
            this.$nextTick(() => {
              if (this.$refs.subjectSearchInput && !this.isLoadingFromUrl) {
                this.$refs.subjectSearchInput.$el.querySelector('input').focus();
              }
            });
          }
        });
      } catch (error) {
        console.error('Error al cargar asignaturas:', error);
        this.subjects = [];
        this.filteredSubjects = [];
        this.goToStep(5);
      } finally {
        this.loadingSubjects = false;
      }
    },

    async saveEducationInfo() {
      if (this.selectedSubjects.length === 0) {
        return;
      }

      this.isSaving = true;

      try {
        // Extraemos los IDs de todas las asignaturas seleccionadas
        const subjectIds = this.selectedSubjects.map(subject => subject.id);

        const educationData = {
          user_id: this.$root.currentUser.userId,
          study_type_id: this.selectedStudyType.id,
          center_id: this.selectedCenter.id,
          course_id: this.selectedCourse.id,
          subject_ids: subjectIds
        };

        if (this.isUniversity && this.selectedUniversityCenter) {
          educationData.university_center_id = this.selectedUniversityCenter.id;
        }

        if (this.selectedCommunity) {
          educationData.community_id = this.selectedCommunity.id;
        }

        const response = await this.axios.post('/education/user-education-complete', educationData);

        if (response.status === 200) {
          console.log('Información educativa guardada correctamente:', response.data);
          this.$emit('completed');
        } else {
          console.error('Error al guardar la información educativa:', response.data);
          alert('No se pudo guardar la información educativa. Por favor, inténtalo de nuevo.');
        }
      } catch (error) {
        console.error('Error al guardar la información educativa:', error);
        alert('Ha ocurrido un error. Por favor, inténtalo de nuevo más tarde.');
      } finally {
        this.isSaving = false;
      }
    },

    // Método para actualizar los parámetros de la URL con el estado actual
    updateUrlParams() {
      // Si estamos cargando desde la URL, no actualizamos para evitar comportamientos indeseados
      if (this.isLoadingFromUrl) return;

      // Creamos un objeto con los parámetros a guardar
      const params = {
        step: this.currentStep
      };

      // Añadimos los ids según el paso en el que estemos
      if (this.selectedStudyType) {
        params.studyType = this.selectedStudyType.id;
      }

      if (this.selectedCenter) {
        params.center = this.selectedCenter.id;
      }

      if (this.selectedCourse) {
        params.course = this.selectedCourse.id;
      }

      if (this.isUniversity && this.selectedUniversityCenter) {
        params.univCenter = this.selectedUniversityCenter.id;
      }

      // Para las asignaturas, guardamos los IDs como una lista separada por comas
      if (this.selectedSubjects.length > 0) {
        params.subjects = this.selectedSubjects.map(s => s.id).join(',');
      }

      // Actualizamos la URL sin recargar la página
      const query = Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');

      const newUrl = window.location.pathname + '?' + query;
      window.history.replaceState({}, '', newUrl);
    },

    // Método para cargar el estado desde los parámetros de la URL
    async loadStateFromUrl() {
      // Obtenemos los parámetros de la URL
      const urlParams = new URLSearchParams(window.location.search);

      // Si no hay parámetros, no hacemos nada
      if (urlParams.size === 0) return;

      try {
        // Activamos el flag para evitar actualizaciones de URL durante la carga
        this.isLoadingFromUrl = true;

        // Primero cargamos los tipos de estudio si hay un studyType
        if (urlParams.has('studyType')) {
          await this.loadStudyTypes();

          // Seleccionamos el tipo de estudio
          const studyTypeId = parseInt(urlParams.get('studyType'));
          const studyType = this.studyTypes.find(st => st.id === studyTypeId);

          if (studyType) {
            this.selectedStudyType = studyType;

            // Cargamos los centros educativos
            await this.loadEducationCentersWithoutNavigation();

            // Si hay un centro seleccionado
            if (urlParams.has('center')) {
              const centerId = parseInt(urlParams.get('center'));
              const center = this.educationCenters.find(c => c.id === centerId);

              if (center) {
                this.selectedCenter = center;

                // Cargamos los cursos
                await this.loadCoursesWithoutNavigation();

                // Si hay un curso seleccionado
                if (urlParams.has('course')) {
                  const courseId = parseInt(urlParams.get('course'));
                  const course = this.courses.find(c => c.id === courseId);

                  if (course) {
                    this.selectedCourse = course;

                    // Si es universidad y hay un centro universitario
                    if (this.isUniversity && urlParams.has('univCenter')) {
                      await this.loadUniversityCentersWithoutNavigation();

                      const univCenterId = parseInt(urlParams.get('univCenter'));
                      const univCenter = this.universityCenters.find(uc => uc.id === univCenterId);

                      if (univCenter) {
                        this.selectedUniversityCenter = univCenter;
                      }
                    }

                    // Buscamos la comunidad y cargamos las asignaturas
                    await this.searchCommunityWithoutNavigation();

                    // Si hay asignaturas seleccionadas
                    if (urlParams.has('subjects')) {
                      const subjectIds = urlParams.get('subjects').split(',').map(id => parseInt(id));

                      // Esperamos a que se carguen las asignaturas
                      if (this.subjects.length === 0) {
                        await this.loadSubjectsWithoutNavigation();
                      }

                      // Seleccionamos las asignaturas
                      this.selectedSubjects = this.subjects.filter(s => subjectIds.includes(s.id));
                    }
                  }
                }
              }
            }
          }
        }

        // Finalmente, establecemos el paso actual
        if (urlParams.has('step')) {
          const step = parseInt(urlParams.get('step'));
          if (step >= 1 && step <= 6) {
            // Verificamos que sea un paso válido según el estado actual
            if (step <= 2 || (step === 3 && this.selectedStudyType) ||
              (step === 4 && this.selectedCourse && this.isUniversity) ||
              (step === 5 && this.selectedCourse) ||
              (step === 6 && this.selectedSubjects.length > 0)) {
              this.currentStep = step;
            }
          }
        }
      } catch (error) {
        console.error('Error al cargar el estado desde la URL:', error);
      } finally {
        // Desactivamos el flag cuando terminamos de cargar
        this.isLoadingFromUrl = false;
      }
    },

    // Método para calcular la distancia de Levenshtein entre dos strings
    levenshteinDistance(a, b) {
      if (!a || !b) return 0;

      const matrix = [];

      // Inicializar la matriz
      for (let i = 0; i <= b.length; i++) {
        matrix[i] = [i];
      }

      for (let j = 0; j <= a.length; j++) {
        matrix[0][j] = j;
      }

      // Rellenar la matriz
      for (let i = 1; i <= b.length; i++) {
        for (let j = 1; j <= a.length; j++) {
          if (b.charAt(i - 1) === a.charAt(j - 1)) {
            matrix[i][j] = matrix[i - 1][j - 1];
          } else {
            matrix[i][j] = Math.min(
              matrix[i - 1][j - 1] + 1, // sustitución
              matrix[i][j - 1] + 1,     // inserción
              matrix[i - 1][j] + 1      // eliminación
            );
          }
        }
      }

      return matrix[b.length][a.length];
    },

    // Normalizar string para búsqueda
    normalizeString(text) {
      if (!text) return '';
      return text.toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // Elimina acentos
        .replace(/[^\w\s]/gi, ''); // Elimina caracteres especiales
    },

    // Calcular relevancia del resultado
    calculateRelevance(itemName, searchTerm, shortName = null) {
      const normalizedName = this.normalizeString(itemName);
      const normalizedSearch = this.normalizeString(searchTerm);

      // Verificar si hay una coincidencia exacta con el nombre corto
      if (shortName) {
        const normalizedShortName = this.normalizeString(shortName);
        if (normalizedShortName === normalizedSearch) {
          return -1; // Máxima prioridad absoluta para coincidencias exactas de nombre corto
        }

        // Verificar si el término de búsqueda coincide exactamente con alguna palabra del nombre corto
        const shortNameWords = normalizedShortName.split(/\s+/);
        if (shortNameWords.some(word => word === normalizedSearch)) {
          return -0.5; // Prioridad muy alta para coincidencias de palabras en nombre corto
        }
      }

      // Verificar si hay una coincidencia exacta con el nombre completo
      if (normalizedName === normalizedSearch) {
        return 0; // Máxima prioridad para nombre completo
      }

      // Verificar si es una coincidencia al inicio (prefijo)
      if (normalizedName.startsWith(normalizedSearch)) {
        return 0.5; // Alta prioridad
      }

      // Si hay nombre corto, verificar si coincide al inicio
      if (shortName) {
        const normalizedShortName = this.normalizeString(shortName);
        if (normalizedShortName.startsWith(normalizedSearch)) {
          return 0.7; // Prioridad alta para coincidencias al inicio del nombre corto
        }
      }

      // Dividir en palabras
      const nameWords = normalizedName.split(/\s+/);
      const searchWords = normalizedSearch.split(/\s+/);

      // Verificar si hay coincidencias exactas de palabras completas
      let exactWordMatches = 0;
      for (const searchWord of searchWords) {
        if (nameWords.some(word => word === searchWord)) {
          exactWordMatches++;
        }
      }

      // Si todas las palabras de búsqueda coinciden exactamente con palabras en el nombre
      if (exactWordMatches === searchWords.length && searchWords.length > 0) {
        return 0.8; // Muy alta prioridad
      }

      // Si algunas palabras coinciden exactamente
      if (exactWordMatches > 0) {
        return 1 + (1 - exactWordMatches / searchWords.length); // Entre 1 y 2 según cuántas palabras coincidan
      }

      // Verificar si alguna palabra empieza con el término de búsqueda
      const anyWordStartsWith = nameWords.some(word => word.startsWith(normalizedSearch));
      if (anyWordStartsWith) {
        return 2; // Prioridad media-alta
      }

      // Verificar si contiene el término de búsqueda en cualquier parte
      if (normalizedName.includes(normalizedSearch)) {
        return 2.5; // Prioridad media
      }

      // Si hay nombre corto, verificar si contiene el término de búsqueda
      if (shortName) {
        const normalizedShortName = this.normalizeString(shortName);
        if (normalizedShortName.includes(normalizedSearch)) {
          return 2.8; // Prioridad media para coincidencias en nombre corto
        }
      }

      // Calcular la mejor coincidencia a nivel de palabra
      let bestWordDistance = Infinity;
      for (const word of nameWords) {
        // Para cada palabra de búsqueda
        for (const searchWord of searchWords) {
          if (searchWord.length > 2) { // Solo considerar palabras significativas
            const distance = this.levenshteinDistance(word, searchWord);
            const normalizedDistance = distance / Math.max(word.length, searchWord.length);

            if (normalizedDistance < bestWordDistance) {
              bestWordDistance = normalizedDistance;
            }
          }
        }
      }

      // Si hay nombre corto, también calcular distancias a nivel de palabra
      if (shortName) {
        const shortNameWords = this.normalizeString(shortName).split(/\s+/);
        for (const word of shortNameWords) {
          for (const searchWord of searchWords) {
            if (searchWord.length > 2) {
              const distance = this.levenshteinDistance(word, searchWord);
              const normalizedDistance = distance / Math.max(word.length, searchWord.length);

              if (normalizedDistance < bestWordDistance) {
                bestWordDistance = normalizedDistance;
              }
            }
          }
        }
      }

      // Si encontramos una buena coincidencia a nivel de palabra
      if (bestWordDistance < 0.3) { // Menos del 30% de diferencia
        return 3 + bestWordDistance * 2; // Entre 3 y 3.6
      }

      // Calcular distancia Levenshtein general y normalizar por longitud
      const distance = this.levenshteinDistance(normalizedName, normalizedSearch);
      const maxLength = Math.max(normalizedName.length, normalizedSearch.length);

      // Normalizar la distancia en relación con la longitud
      return 4 + (distance / (maxLength || 1)) * 6; // Entre 4 y 10
    },

    // Métodos para filtrar según la búsqueda
    filterCenters() {
      if (!this.searchCenter || this.searchCenter.trim() === '') {
        this.filteredCenters = this.educationCenters;
      } else {
        const search = this.searchCenter.trim();

        // Filtrar primero por subcadenas
        let tempResults = this.educationCenters.filter(center => {
          const normalizedName = this.normalizeString(center.name);
          const normalizedShortName = center.short_name ? this.normalizeString(center.short_name) : '';
          const normalizedSearch = this.normalizeString(search);

          // Incluir resultados que contengan cualquier palabra de búsqueda en nombre o nombre corto
          const searchWords = normalizedSearch.split(/\s+/);
          return searchWords.some(word =>
            normalizedName.includes(word) ||
            (normalizedShortName && normalizedShortName.includes(word))
          );
        });

        // Si no hay resultados, mostrar todos para aplicar ranking por relevancia
        if (tempResults.length === 0) {
          tempResults = [...this.educationCenters];
        }

        // Calcular relevancia para cada centro educativo
        const relevanceMap = new Map();
        for (let i = 0; i < tempResults.length; i++) {
          const center = tempResults[i];
          // Pasar el nombre corto como tercer parámetro en lugar de calcular dos relevancias separadas
          const relevance = this.calculateRelevance(center.name, search, center.short_name);
          relevanceMap.set(center.id, relevance);
        }

        // Ordenar usando el mapa de relevancia (valores más bajos = más relevantes)
        this.filteredCenters = tempResults.sort((a, b) => {
          return relevanceMap.get(a.id) - relevanceMap.get(b.id);
        });
      }
    },

    filterCourses() {
      if (!this.searchCourse || this.searchCourse.trim() === '') {
        this.filteredCourses = this.courses;
      } else {
        const search = this.searchCourse.trim();

        // Filtrar primero por subcadenas
        let tempResults = this.courses.filter(course => {
          const normalizedName = this.normalizeString(course.name);
          const normalizedShortName = course.short_name ? this.normalizeString(course.short_name) : '';
          const normalizedSearch = this.normalizeString(search);

          // Incluir resultados que contengan cualquier palabra de búsqueda en nombre o nombre corto
          const searchWords = normalizedSearch.split(/\s+/);
          return searchWords.some(word =>
            normalizedName.includes(word) ||
            (normalizedShortName && normalizedShortName.includes(word))
          );
        });

        // Si no hay resultados, mostrar todos para aplicar ranking por relevancia
        if (tempResults.length === 0) {
          tempResults = [...this.courses];
        }

        // Calcular relevancia para cada curso
        const relevanceMap = new Map();
        for (let i = 0; i < tempResults.length; i++) {
          const course = tempResults[i];
          // Pasar el nombre corto como tercer parámetro en lugar de calcular dos relevancias separadas
          const relevance = this.calculateRelevance(course.name, search, course.short_name);
          relevanceMap.set(course.id, relevance);
        }

        // Ordenar usando el mapa de relevancia (valores más bajos = más relevantes)
        this.filteredCourses = tempResults.sort((a, b) => {
          return relevanceMap.get(a.id) - relevanceMap.get(b.id);
        });
      }
    },

    filterUniversityCenters() {
      if (!this.searchUniversityCenter || this.searchUniversityCenter.trim() === '') {
        this.filteredUniversityCenters = this.universityCenters;
      } else {
        const search = this.searchUniversityCenter.trim();

        // Filtrar primero por subcadenas
        let tempResults = this.universityCenters.filter(center => {
          const normalizedName = this.normalizeString(center.name);
          const normalizedShortName = center.short_name ? this.normalizeString(center.short_name) : '';
          const normalizedSearch = this.normalizeString(search);

          // Incluir resultados que contengan cualquier palabra de búsqueda en nombre o nombre corto
          const searchWords = normalizedSearch.split(/\s+/);
          return searchWords.some(word =>
            normalizedName.includes(word) ||
            (normalizedShortName && normalizedShortName.includes(word))
          );
        });

        // Si no hay resultados, mostrar todos para aplicar ranking por relevancia
        if (tempResults.length === 0) {
          tempResults = [...this.universityCenters];
        }

        // Calcular relevancia para cada centro universitario
        const relevanceMap = new Map();
        for (let i = 0; i < tempResults.length; i++) {
          const center = tempResults[i];
          // Pasar el nombre corto como tercer parámetro en lugar de calcular dos relevancias separadas
          const relevance = this.calculateRelevance(center.name, search, center.short_name);
          relevanceMap.set(center.id, relevance);
        }

        // Ordenar usando el mapa de relevancia (valores más bajos = más relevantes)
        this.filteredUniversityCenters = tempResults.sort((a, b) => {
          return relevanceMap.get(a.id) - relevanceMap.get(b.id);
        });
      }
    },

    filterSubjects() {
      if (!this.searchSubject || this.searchSubject.trim() === '') {
        this.filteredSubjects = this.subjects;
      } else {
        const search = this.searchSubject.trim();

        // Filtrar primero por subcadenas
        let tempResults = this.subjects.filter(subject => {
          const normalizedName = this.normalizeString(subject.name);
          const normalizedShortName = subject.short_name ? this.normalizeString(subject.short_name) : '';
          const normalizedSearch = this.normalizeString(search);

          // Incluir resultados que contengan cualquier palabra de búsqueda en nombre o nombre corto
          const searchWords = normalizedSearch.split(/\s+/);
          return searchWords.some(word =>
            normalizedName.includes(word) ||
            (normalizedShortName && normalizedShortName.includes(word))
          );
        });

        // Si no hay resultados, mostrar todos para aplicar ranking por relevancia
        if (tempResults.length === 0) {
          tempResults = [...this.subjects];
        }

        // Calcular relevancia para cada asignatura
        const relevanceMap = new Map();
        for (let i = 0; i < tempResults.length; i++) {
          const subject = tempResults[i];
          // Pasar el nombre corto como tercer parámetro en lugar de calcular dos relevancias separadas
          const relevance = this.calculateRelevance(subject.name, search, subject.short_name);
          relevanceMap.set(subject.id, relevance);
        }

        // Ordenar usando el mapa de relevancia (valores más bajos = más relevantes)
        this.filteredSubjects = tempResults.sort((a, b) => {
          return relevanceMap.get(a.id) - relevanceMap.get(b.id);
        });
      }
    },

    async addCustomSubject() {
      if (!this.newSubjectName || this.newSubjectName.trim() === '') {
        return;
      }

      this.addingCustomSubject = true;

      try {
        const customSubjectData = {
          name: this.newSubjectName,
          user_id: this.userId,
          study_id: this.selectedCourse.id,
          center_id: this.selectedCenter.id
        };

        // Si es universidad, añadimos el centro universitario
        if (this.isUniversity && this.selectedUniversityCenter) {
          customSubjectData.university_center_id = this.selectedUniversityCenter.id;
        }

        console.log('Enviando datos de asignatura personalizada:', customSubjectData);

        const response = await this.axios.post('/education/custom-subjects', customSubjectData);

        if (response.status === 200 && response.data.subject) {
          console.log('Asignatura personalizada añadida correctamente:', response.data);

          // Agregamos la nueva asignatura a nuestra lista de asignaturas
          const newSubject = {
            ...response.data.subject,
            is_verified: 0 // Asegurarnos de que se marca como no verificada
          };

          // Añadimos al array de subjects y también lo seleccionamos
          this.subjects.unshift(newSubject);
          this.filteredSubjects = [...this.subjects]; // Actualizamos el filtrado
          this.toggleSubject(newSubject); // Seleccionamos la asignatura automáticamente

          // Limpiamos el campo
          this.newSubjectName = '';

          // Ocultamos el formulario adicional si estaba visible
          this.showAddMoreSubjectsForm = false;

          // Notificación de éxito (sin usar store)
          // alert('Asignatura añadida correctamente (pendiente de revisión)');
        } else {
          console.error('Error al añadir la asignatura personalizada:', response.data);
          alert('No se pudo añadir la asignatura personalizada');
        }
      } catch (error) {
        console.error('Error al añadir la asignatura personalizada:', error);
        // Verificar si es un error de duplicado
        if (error.response && error.response.status === 409) {
          alert('Ya existe una asignatura con ese nombre en este curso');
        } else {
          alert('Ha ocurrido un error al añadir la asignatura');
        }
      } finally {
        this.addingCustomSubject = false;
      }
    },
  },
  mounted() {
    this.fetchUserSubjects();
    
    this.loadStudyTypes().then(() => {
      // Después de cargar los tipos de estudio, intentamos cargar el estado desde la URL
      this.loadStateFromUrl();
    });

    this.resetScroll();

    const stepper = this.$el.querySelector('.education-stepper');
    if (stepper) {
      stepper.addEventListener('change', this.resetScroll);
    }

    // Escuchar eventos de navegación para actualizar el estado cuando el usuario use los botones del navegador
    window.addEventListener('popstate', this.loadStateFromUrl);
  },
  beforeDestroy() {
    const stepper = this.$el.querySelector('.education-stepper');
    if (stepper) {
      stepper.removeEventListener('change', this.resetScroll);
    }

    // Eliminar el listener de popstate
    window.removeEventListener('popstate', this.loadStateFromUrl);
  },
  watch: {
    currentStep(val, oldVal) {
      this.$emit('update:step', val);
      this.resetScroll();

      // Limpiar búsquedas cuando cambiamos entre pasos
      if (oldVal === 2) this.searchCenter = '';
      if (oldVal === 3) this.searchCourse = '';
      if (oldVal === 4) this.searchUniversityCenter = '';
      if (oldVal === 5) this.searchSubject = '';

      // Reiniciar filtros solo si no los hemos limpiado ya en clearVariablesFromStep
      if (oldVal === 2 && this.educationCenters.length > 0) {
        this.filteredCenters = [...this.educationCenters];
      }
      if (oldVal === 3 && this.courses.length > 0) {
        this.filteredCourses = [...this.courses];
      }
      if (oldVal === 4 && this.universityCenters.length > 0) {
        this.filteredUniversityCenters = [...this.universityCenters];
      }
      if (oldVal === 5 && this.subjects.length > 0) {
        this.filteredSubjects = [...this.subjects];
      }

      // Cuando entramos al paso 5, recargamos las asignaturas si es necesario
      if (val === 5 && this.subjects.length === 0 && this.canSearchSubjects) {
        this.loadSubjectsWithoutNavigation();
      }

      // Establecer autofocus en el campo de búsqueda correspondiente
      this.$nextTick(() => {
        if (!this.isLoadingFromUrl) {
          if (val === 2 && this.$refs.centerSearchInput) {
            this.$refs.centerSearchInput.$el.querySelector('input').focus();
          } else if (val === 3 && this.$refs.courseSearchInput) {
            this.$refs.courseSearchInput.$el.querySelector('input').focus();
          } else if (val === 4 && this.$refs.universityCenterSearchInput) {
            this.$refs.universityCenterSearchInput.$el.querySelector('input').focus();
          } else if (val === 5 && this.$refs.subjectSearchInput) {
            this.$refs.subjectSearchInput.$el.querySelector('input').focus();
          }
        }
      });
    }
  }

}
</script>

<style scoped>
.university-icon>>>.v-image__image {
  border-radius: 9px;
}

.option-card {
  border-radius: 12px !important;
  cursor: pointer;
  border: 2px solid #e0e0e0;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

/* .option-card:hover {
  border-color: #42b848;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.05) !important;
} */

.selected-option {
  border: 2px solid #42b848 !important;
  background-color: #e9feec !important;
}

.search-container {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: white;
}

.search-input>>>.v-input__slot {
  background-color: #f5f5f5 !important;
  border-radius: 12px !important;
}

.search-input>>>.v-text-field__slot input::placeholder {
  color: #757575;
  font-size: 14px;
}

.search-input>>>.v-input__slot {
  box-shadow: none !important;
}

.search-input>>>.v-input__prepend-inner {
  margin-top: 3px !important;
}

.education-form {
  margin: 0 auto;
  width: 100%;
}

.question-container {
  max-width: 800px;
  margin: 0 auto;
  background-color: white;
  border-radius: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  width: 100%;
  position: relative;
}

.primary-btn {
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 800 !important;
  font-size: 0.9rem !important;
  height: 38px !important;
  border-radius: 12px !important;
  border: 2px solid #4dd453 !important;
  padding-left: 24px !important;
  padding-right: 24px !important;
  background: #4dd453 !important;
  box-shadow: 0 4px 0 #42b848 !important;
  color: white !important;
}

.primary-btn:hover {
  filter: brightness(1.02);
  box-shadow: 0 4px 0 #58a700 !important;
}

.primary-btn:active {
  box-shadow: 0 0 0 #58a700 !important;
  transform: none !important;
}

.education-stepper {
  background: transparent !important;
  box-shadow: none !important;
}

.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  border: 2px solid #cccccc !important;
  background: #e0e0e0 !important;
  box-shadow: 0 4px 0 #b0b0b0 !important;
  color: #888888 !important;
  opacity: 0.7;
  font-size: 0.9rem !important;
  height: 38px !important;
  cursor: not-allowed;
}

h2 {
  font-family: "Nunito", "DINRounded", "Inter", sans-serif !important;
  font-weight: 900 !important;
  color: #4b4b4b !important;
  letter-spacing: -0.03em !important;
  font-size: 2rem !important;
  margin-bottom: 1.5rem !important;
}

.subtitle-1,
p,
span,
div {
  font-family: "Nunito", "DINRounded", "Inter", sans-serif !important;
  color: #4b4b4b;
}

:deep(.v-step__circle) {
  background-color: #4dd453 !important;
  color: white !important;
}

:deep(.v-stepper__step--active) {
  color: #4dd453 !important;
}

:deep(.v-stepper__step--active .v-step__circle) {
  background-color: #4dd453 !important;
}

:deep(.v-stepper__step--complete) {
  color: #4dd453 !important;
}

:deep(.v-stepper__content) {
  border-left: none;
}

:deep(.v-stepper__header) {
  box-shadow: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  margin-bottom: 24px;
}

.option-card {
  border-radius: 12px !important;
  cursor: pointer;
  border: 2px solid #e0e0e0;
}

/* .option-card:hover {
  border-color: #42b848;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.05) !important;
} */

.selected-option {
  border: 2px solid #42b848 !important;
  background-color: #e9feec !important;
}

.subject-chip {
  background-color: #e9feec !important;
  border: 1px solid #4dd453 !important;
  color: #42b848 !important;
  border-radius: 5px !important;
  margin-right: 8px;
  margin-bottom: 8px;
}

.selected-subjects-container {
  background-color: #f8f8f8;
  border-radius: 12px;
  padding: 16px;
}

.options-list-container {
  position: relative;
}

.options-list {
  overflow-y: auto;
  padding-right: 8px;
  background-color: #f9f9f9;
  padding: 16px;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.sticky-header {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 10;
  padding-bottom: 8px;
}

.options-list::-webkit-scrollbar {
  width: 8px;
}

.options-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.options-list::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
}

.options-list::-webkit-scrollbar-thumb:hover {
  background: #aaa;
}

.summary-card {
  border-radius: 16px !important;
  border: 1px solid #e0e0e0 !important;
  background-color: #f9f9f9 !important;
}

.summary-card p.font-weight-bold {
  color: #42b848;
  font-weight: 700 !important;
}

.gradient-text {
  background: linear-gradient(90deg, #4dd453, #4fee57);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 900;
}

.select-all-btn {
  border-radius: 8px !important;
  text-transform: none !important;
  font-size: 0.85rem !important;
  letter-spacing: 0 !important;
  font-weight: 600 !important;
}

.select-all-btn:hover {
  background-color: rgba(66, 184, 72, 0.1) !important;
}

.stepper-items-container {
  position: relative;
  overflow: hidden;
}

/* Eliminar las transiciones de Vuetify */
:deep(.v-stepper),
:deep(.v-stepper__content),
:deep(.v-stepper-items),
:deep(.v-stepper__wrapper) {
  transition: none !important;
}

/* Deshabilitar todas las transiciones */
* {
  transition: none !important;
  animation: none !important;
}

.v-btn {
  transition: none !important;
}

.option-card,
.option-card:hover,
.option-card:active {
  transition: none !important;
}

/* Quitar efectos de hover y active con transform */
.primary-btn:active {
  box-shadow: 0 0 0 #58a700 !important;
  transform: none !important;
}

/* Estilos para asignaturas personalizadas */
.custom-subject {
  border-color: #FFF3E0 !important;
  background-color: #FFFDF9 !important;
}

.custom-subject.selected-option {
  background-color: #e9feec !important;
  border-color: #42b848 !important;
}

.custom-subject-form {
  background-color: #f9f9f9;
  border-radius: 12px;
  padding: 16px;
  margin-top: 10px;
}

.no-subjects-message {
  background-color: #f9f9f9;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
}

/* Estilos para el breadcrumb */
.breadcrumb-container {
  padding: 8px 0;
  display: flex;
  align-items: center;
  min-height: 60px;
}

.breadcrumb-path {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 14px;
}

.breadcrumb-item {
  color: #757575;
  font-weight: 500;
  transition: color 0.2s;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
}

.breadcrumb-item.clickable {
  cursor: pointer;
  position: relative;
}

.breadcrumb-item.clickable:hover {
  color: #42b848;
  text-decoration: underline;
}

.breadcrumb-item.clickable:active {
  color: #308a35;
}

.current-step {
  color: #42b848;
  font-weight: 600;
}

/* Asegurar que los iconos de flechas sean del mismo color */
.breadcrumb-path .v-icon {
  color: #bdbdbd !important;
  font-size: 18px !important;
}

@media (max-width: 600px) {
  .breadcrumb-item {
    max-width: 100px;
  }
}



.search-input>>>svg {
  height: 18px;
  width: 18px;
}
</style>